import React, { memo } from 'react';
import { KpiCard } from '../components/dashboard/KpiCard';
import { AgingChart } from '../components/dashboard/AgingChart';
import { NextActionsWidget } from '../components/dashboard/NextActionsWidget';
import { RiskMapWidget } from '../components/dashboard/RiskMapWidget';
import { RiskyClientsWidget } from '../components/dashboard/RiskyClientsWidget';
import { Card } from '../components/ui/Card';
import { ClockIcon, CalendarIcon, TrendingUpIcon, AlertCircleIcon, CreditCardIcon, MailIcon } from 'lucide-react';
export function Dashboard() {
  return <div className="space-y-6 pb-16" data-id="element-2038">
      <div data-id="element-2039">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2040">Dashboard</h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-2041">
          Monitora i tuoi crediti e intervieni sulle fatture scadute.
        </p>
      </div>
      {/* KPI Section */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-2042">
        <KpiCard title="DSO (Giorni Medi di Incasso)" value="45 giorni" change={{
        value: '3 giorni',
        positive: false
      }} icon={<ClockIcon className="h-5 w-5" data-id="element-2044" />} color="purple" data-id="element-2043" />
        <KpiCard title="Crediti Scaduti" value="€180.000" change={{
        value: '12%',
        positive: false
      }} icon={<AlertCircleIcon className="h-5 w-5" data-id="element-2046" />} color="pink" data-id="element-2045" />
        <KpiCard title="Piani di Pagamento Attivi" value="24" change={{
        value: '4',
        positive: true
      }} icon={<CalendarIcon className="h-5 w-5" data-id="element-2048" />} color="blue" data-id="element-2047" />
        <KpiCard title="Recuperato Ultimi 30 Giorni" value="€85.500" change={{
        value: '15%',
        positive: true
      }} icon={<TrendingUpIcon className="h-5 w-5" data-id="element-2050" />} color="green" data-id="element-2049" />
        <KpiCard title="Tasso di Successo SDD" value="92%" change={{
        value: '3%',
        positive: true
      }} icon={<CreditCardIcon className="h-5 w-5" data-id="element-2052" />} color="orange" data-id="element-2051" />
        <KpiCard title="Tasso di Apertura Email" value="78%" change={{
        value: '5%',
        positive: true
      }} icon={<MailIcon className="h-5 w-5" data-id="element-2054" />} color="blue" data-id="element-2053" />
      </div>
      {/* Charts and Widgets */}
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2" data-id="element-2055">
        <AgingChart data-id="element-2056" />
        <RiskMapWidget data-id="element-2057" />
      </div>
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3" data-id="element-2058">
        <div className="lg:col-span-2" data-id="element-2059">
          <NextActionsWidget data-id="element-2060" />
        </div>
        <Card title="Statistiche Rapide" data-id="element-2061">
          <div className="space-y-4" data-id="element-2062">
            <div className="flex justify-between" data-id="element-2063">
              <span className="text-sm text-gray-500" data-id="element-2064">Clienti Totali</span>
              <span className="text-sm font-medium" data-id="element-2065">142</span>
            </div>
            <div className="flex justify-between" data-id="element-2066">
              <span className="text-sm text-gray-500" data-id="element-2067">Fatture Aperte</span>
              <span className="text-sm font-medium" data-id="element-2068">287</span>
            </div>
            <div className="flex justify-between" data-id="element-2069">
              <span className="text-sm text-gray-500" data-id="element-2070">
                Promemoria in Attesa
              </span>
              <span className="text-sm font-medium" data-id="element-2071">35</span>
            </div>
            <div className="flex justify-between" data-id="element-2072">
              <span className="text-sm text-gray-500" data-id="element-2073">PEC Inviate (Mese)</span>
              <span className="text-sm font-medium" data-id="element-2074">18</span>
            </div>
            <div className="flex justify-between" data-id="element-2075">
              <span className="text-sm text-gray-500" data-id="element-2076">
                Ritardo Medio Pagamento
              </span>
              <span className="text-sm font-medium" data-id="element-2077">15 giorni</span>
            </div>
          </div>
        </Card>
      </div>
      {/* Elenco dei clienti più rischiosi */}
      <div className="grid grid-cols-1 gap-5" data-id="element-2078">
        <RiskyClientsWidget data-id="element-2079" />
      </div>
    </div>;
}